import React, {Component} from "react";
import {connect} from "react-redux";
import {Col, message, Radio, Row} from 'antd';
import { getSupportedSpecimenType } from "../utils/utils";
import { specimenType, DisplaySettingType,  } from "../utils/const";
import { specimenTypeOptions, getViewerSettingDropdown, getNameFromId } from "../component/scanner/slot_component_utils";
import {getDeviceStatus} from "../redux_actions/device_status.action";
import _ from 'lodash';
import { get, patch, post } from "helper/request";
import {error_manager} from "helper/error_manager";



let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BM': specimenType.BM,
    'BLOOD': specimenType.BLOOD,
    'AUTO': specimenType.AUTO
}

const device_id = '1';
let server_up = false;
let use_stain_settings = false;

class ScanningProfileView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            specimenType: specimenType.AUTO,
        }
    }

    componentDidMount = () => {
        this.updateServerStatus();
    }

    componentDidUpdate = () => {
        this.updateServerStatus();
    }

    onSpecimenTypeChange = (event) => {
        const specimen = event.target.value;
        let id = this.state.defaultStainSettings[specimen]["default_setting"]
        let name = getNameFromId(this.state.allDisplaySettings, id)
        this.setState({
            displaySetting: name,
            specimenType: specimen
        });
    }

    fetchAllDisplaySettings = () =>
        get(`/api/display/settings/?type=${DisplaySettingType.SLIDE}&ordering=-last_used&view=list`)
            .then((settings) => {
                console.log(this.state.allDisplaySettings)
                let dispSetting =
                        settings.reduce((settings, setting) => Object.assign(settings, {
                            [setting.id]: setting,
                        }), {})
                        this.setState({
                            allDisplaySettings: dispSetting
                        })
                if (use_stain_settings) {
                    this.setState({
                        specimenType: specimenType.HNE_TISSUE
                    })
                }
                this.fetchAllStainSettings(dispSetting)
            })
            .catch((error) => error_manager("Failed to fetch display settings", error))

    updateServerStatus() {
        if (_.isEmpty(this.props.deviceStatus)) {
            this.props.dispatch(getDeviceStatus(device_id));
        }
        else if ((((this.props.deviceStatus[device_id] || {}).scanner_health || {}).server_up)) {
            if((((this.props.deviceStatus[device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold !== true){
                let supportedSpecs = (((this.props.deviceStatus[device_id] || {}).scanner_health || {}).scanner_response || {}).supportedSpecimenTypes;
                SPECIMEN = getSupportedSpecimenType(SPECIMEN, supportedSpecs, true);
                use_stain_settings = true;
            }
            if (this.state.allDisplaySettings===undefined) {
                this.fetchAllDisplaySettings();
            }
            server_up = true;
        }
    }

    fetchAllStainSettings(all_Settings) {
        post(`/api/populate/stain/settings/`, Object.values(SPECIMEN))
            .then(() => {
                get(`/api/stain/settings/`)
            .then(settings => {
                let stainSetting = settings.reduce((settings, setting) => Object.assign(settings, {
                    [setting.stain_name]: setting,
                }), {})
                this.setState({
                    defaultStainSettings: stainSetting,
                })
                let id = stainSetting[this.state.specimenType]["default_setting"]
                let name = getNameFromId(all_Settings, id)
                this.setState({displaySetting: name});
            })
            .catch(error => error_manager("Failed to fetch Stain settings", error))
            }).catch(error => error_manager("Failed to fetch Stain settings", error))
    }

    saveSpecimenDefaults = (value) => {
        let default_setting = {
        "default_setting": value
        }
        patch(`/api/stain/settings/${this.state.specimenType}/`, default_setting)
        .then((setting) => {
            let scanningProfile = this.state.allDisplaySettings[value];
            let changedStainSetting = this.state.defaultStainSettings;
            changedStainSetting[this.state.specimenType].default_setting = setting.default_setting
            this.setState({
                defaultStainSettings: changedStainSetting,
                displaySetting: scanningProfile.name
            })
            message.success("Updated Default Setting!")
        })
        .catch(error => error_manager("Failed To Update Default Setting", error))
    }

    render() {
        return (<div id="scanner-div">
            <Row>
                <Col className="scanner-name arial-font" span={24}>
                    {"Scanning Profile"}
                </Col>
            </Row>
            <br></br>
            <br></br>
            {server_up ?
            <Col>
                <Row>
                    <Col span={12}>
                    <Row>
                        <Col span={20} style={{fontSize: '24px', textAlign: 'center', verticalAlign: 'middle'}}>
                            <b>Change Default Scanning Profile</b>
                        </Col>
                    </Row>
                    {use_stain_settings?
                    <Row>
                        <Col span={20} offset={1}>
                            <br></br>
                            <Row>
                                <Row className="arial-font" style={{fontSize: 13}}><b>Select Specimen Type</b></Row>
                                <Radio.Group value={(this.state.specimenType || '').toUpperCase()}
                                            buttonStyle="solid"
                                            onChange={this.onSpecimenTypeChange}
                                            size="small"
                                >
                                    {specimenTypeOptions(Object.keys(SPECIMEN))}
                                </Radio.Group>
                            </Row>
                        </Col>
                    </Row>
                    : null}
                    <br/>
                    <Row>
                        <Col span={20} offset={1}>
                            {getViewerSettingDropdown(this.state.specimenType, this.state.displaySetting, this.state.allDisplaySettings, this.saveSpecimenDefaults)}
                        </Col>
                    </Row>
                    </Col>
                    <Col span={12}>
                        <Row>
                            <Col span={20} offset={1} style={{fontSize: '16px'}}>
                                <b>Scanning Profile Guide:</b>
                                <br/><br/>
                                1. Scanning Profile can be used to set the configs to fit any or each tissue differently. <br/>
                                2. The Default Profile to be used for each specimen type can be changed here. <br/>
                                3. The Profile to be used can also be changed for any particular scan when you are selecting area for that scan. <br/>
                                4. Individual Values for each Field can also be modified from Advanced Mode while selecting the scan area. <br/>
                                <br/>For further help, contact <b>Morphle Support</b>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            : 
            <Row>
                <Col className="scanner-name arial-font" span={24}>
                    {"Scanner Not Reachable"}
                    <br/>
                    {"Scanning Profile can only be Modified with the Scanner Connected"}
                    <br/>
                    {"Please Initialize the Scanner and Try Again"}
                </Col>
            </Row>}
        </div>)
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        deviceStatus: state.deviceStatusReducer,
    };
};

export default connect(mapStateToProps)(ScanningProfileView);
